import { useEffect, useCallback } from 'react'

type KeyHandler = (e: KeyboardEvent) => void
type KeyMap = Record<string, KeyHandler>

export function useHotkeys(keyMap: KeyMap) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      // 忽略输入框中的快捷键
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        event.target instanceof HTMLSelectElement
      ) {
        return
      }

      const key = [
        event.ctrlKey ? 'Ctrl' : '',
        event.shiftKey ? 'Shift' : '',
        event.altKey ? 'Alt' : '',
        event.key.toUpperCase(),
      ]
        .filter(Boolean)
        .join('+')

      const handler = keyMap[key]
      if (handler) {
        event.preventDefault()
        handler(event)
      }
    },
    [keyMap]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])
} 